import React from "react";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import PortalApp from "./portal/PortalApp";
import { config } from "./config";
import { ViewerProvider } from "./members/Viewer";
import "@fontsource/dm-sans/latin-400.css";
import "@fontsource/dm-sans/latin-500.css";
import "@fontsource/dm-sans/latin-700.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "./portal/portal.css";
const DemoPlayer = lazy(() => import("./portal/DemoPlayer"));
const AccountPage = lazy(() => import("./members/AccountPage"));
const StoriesApp = lazy(() => import("./App"));
const isDemoPlayer = location.pathname.replace(/\/$/, "") === "/preview/player";
const isAccount = location.pathname.replace(/\/$/, "") === "/account";
const isStories = config.demo && (location.pathname.replace(/\/$/, "") === "/stories" || /^#\/(watch|series|profile|library|discover)(\/|$)/.test(location.hash));
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ViewerProvider>{isAccount ? <Suspense fallback={<div className="player-loading">Loading your account…</div>}><AccountPage /></Suspense> : isStories ? <Suspense fallback={<div className="player-loading">Loading stories…</div>}><StoriesApp /></Suspense> : isDemoPlayer && config.demo ? (
      <Suspense fallback={<div className="player-loading">Loading video…</div>}>
        <DemoPlayer />
      </Suspense>
    ) : (
      <PortalApp />
    )}</ViewerProvider>
  </React.StrictMode>,
);
